/** Per-route document titles, keyed by browser path. */
export const TITLES: Record<string, string> = {
  "/": "Akhshy Ganesh — AI engineer, building in public",
  "/vault": "Vault · Akhshy Ganesh",
  "/prompts": "Prompts · Akhshy Ganesh",
  "/ritual": "Ritual · Akhshy Ganesh",
  "/projects": "Projects · Akhshy Ganesh",
};

export function titleForPath(pathname: string): string {
  return TITLES[pathname] ?? "Akhshy Ganesh — AI engineer, building in public";
}
